import { ArrowPathIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure} from "@nextui-org/react";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ControlledReactSelect from "../../../../elements/ControlledReactSelect";
import useListCompany from "../../../../../hooks/useListCompany";
import useSWR from "swr";
import { getFetcher, postFetcher } from "../../../../../services/api";
import { reportPreviewValidation } from "../../../../../services/validation/report-preview.validation";
import { isResponseErrorObject } from "../../../../../services/helpers";
import { useEffect } from "react";

export default function ModalReportReview({ endpoint, mutate, selectedCompany, selectedPeriod, setSelectedCompany, setSelectedPeriod  }) {
    const {isOpen, onOpen, onOpenChange, onClose} = useDisclosure(); 
    const { control, setValue, reset, handleSubmit, formState: { isSubmitting } } = useForm({ resolver: yupResolver(reportPreviewValidation) })
    const { dataCompany, isLoadingCompany } = useListCompany()
    const { data: dataPeriod, isLoading: isLoadingPeriod } = useSWR('/api/period/all', getFetcher)

    function handleCloseModal() {
        reset({
            companyId: selectedCompany?.value ?? '',
            periodId: selectedPeriod?.value ?? ''
        })
        onClose();
    }

    useEffect(() => {
        if (selectedCompany?.value && selectedPeriod?.value) {
            setValue('companyId', selectedCompany.value)
            setValue('periodId', selectedPeriod.value)
            reset({
                companyId: selectedCompany?.value ?? '',
                periodId: selectedPeriod?.value ?? ''
            })
        }

    }, [selectedCompany, selectedPeriod])

    async function handleOnSubmit(data) {    
        try {
            await postFetcher(endpoint, data)
            toast.success("Laporan diterima.");
            setSelectedCompany({ value: data.companyId, label: dataCompany?.data?.find((item) => item.id === data.companyId).name })
            setSelectedPeriod({ value: data.periodId, label: dataPeriod?.data?.find((item) => item.id === data.periodId).name })
            mutate();
            onClose();
        } catch (error) {
            isResponseErrorObject(error.response.data.message)
                ? Object.entries(error.response.data.message).forEach(([key, value]) => {
                    toast.error(value);
                })
                : toast.error(error.response.data.message)
        }
    }

    return (
        <>
            <Button size="sm" color="primary"onPress={onOpen} startContent={<ArrowPathIcon className="size-4" />}>Review Laporan</Button>
            <Modal scrollBehavior="inside" hideCloseButton isOpen={isOpen} onOpenChange={onOpenChange} onClose={handleCloseModal}>
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader></ModalHeader>
                            <ModalBody>
                                <form className="flex flex-col gap-3" onSubmit={handleSubmit(handleOnSubmit)}>
                                    <div className="flex flex-col items-center mb-6">
                                        <CheckCircleIcon className="size-16 stoke-2 stroke-primary"/>
                                        <span className='text-2xl font-semibold'>Terima Laporan</span>
                                        <span className='text-medium text-center'>Pengelola akan menerima surat telah selesai lapor</span>
                                    </div>
                                    <ControlledReactSelect
                                        control={control}
                                        options={dataCompany?.data?.map((item) => ({label: item.name, value: item.id}))}
                                        isLoading={isLoadingCompany}
                                        name="companyId"
                                        label="Perusahaan"
                                    />
                                    <ControlledReactSelect
                                        control={control}
                                        options={dataPeriod?.map((item) => ({label: item.name, value: item.id}))}
                                        isLoading={isLoadingPeriod}
                                        name="periodId"
                                        label="Periode"
                                    />
                                    {/* <ControlledDropZone 
                                        control={control} 
                                        label={'File Surat Telah Lapor'} 
                                        name="documents" 
                                        setValue={setValue} 
                                        placeholder="Tarik atau klik untuk upload file"
                                        acceptedFile="pdf"
                                    /> */}
                                    <div className="flex justify-end gap-2 mt-3">
                                        <Button isDisabled={isSubmitting} className='bg-line text-ink-500' variant="faded" onPress={onClose}>
                                            Batal
                                        </Button>
                                        <Button isLoading={isSubmitting} isDisabled={isSubmitting} type="submit" color="primary">
                                            Terima
                                        </Button>
                                    </div>
                                </form>
                            </ModalBody>
                            <ModalFooter className='flex items-center justify-center'>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
}